import { getAllSpecializationAreasReq } from "../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../components/ui/InputField1"
import FileInput from "../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"


function Parenting({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b3f"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          label="Qualifications in Child Development or Parenting Strategies *"
          defaultValue={specialist?.profile?.specializationCertificate || []}
          errText="Please upload qualifications in child development or parenting strategies"
          placeholderText="Upload Qualifications in Child Development or Parenting Strategies"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Areas of Expertise *"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="experience"
          label="Professional Experience *"
          placeholder="Enter Professional Experience *"
          errText="Please enter professional experience"
          defaultValue={specialist?.profile?.experience || ""}
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Section for Credentials"
          placeholderText="Upload Additional Certificates"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Register as a Parenting Expert. Your insights and strategies in parenting can support families in fostering a nurturing and understanding environment. Fill in your professional details to begin guiding our community
      </Typography>
    </Fragment>
  )
}

export default Parenting